// The detector's labels, in the words a manager reads.

const MATCH_WORDS: Record<string, string> = {
  "a-number": "the same A-number",
  "drive-folder": "the same Drive folder",
  "name-dob": "the same name and date of birth",
  "file-hash": "a document in common",
};

/** "the same A-number and the same Drive folder" */
export function matchPhrase(matchedBy: string[]): string {
  const words = matchedBy.map((m) => MATCH_WORDS[m] ?? m);
  if (words.length === 0) return "the same details";
  if (words.length === 1) return words[0];
  return `${words.slice(0, -1).join(", ")} and ${words[words.length - 1]}`;
}
